module.exports = __webpack_public_path__ + "static/media/eve-ust.77043242.svg";